import Vue from 'vue'

const client = () => Vue.prototype.$api

export default {
  getAllUserChats () {
    return client().get('chats')
  },
  getChatById (appointmentId) {
    return client().get(`chats/${appointmentId}`)
  },
  getPastChat (appointmentId) {
    return client().get(`chats/${appointmentId}`, { params: {isPast: true} })
  },
  async createChat (data) {
    return client().post('chats', data)
  },
  finishChat (appointmentId, request) {
    return client().post(`appointments-consolidation/chat/${appointmentId}`, request)
  },
  getChatMessages (appointmentId, pastChat = false) {
    return client().get(`chats/${appointmentId}/messages`, { params: {pastChat: pastChat} })
  },
  sendMessage (appointmentId, chatMessage) {
    return client().post(`chats/${appointmentId}/messages`, chatMessage)
  },
  deleteMessage (appointmentId, messageId){
    return client().delete(`chats/${appointmentId}/messages/${messageId}`)
  },
  getMessage (appointmentId, messageId){
    return client().get(`chats/${appointmentId}/messages/${messageId}`, { loading: false })
  },
  editMessage (appointmentId, messageId, editedMessage){
    return client().put(`chats/${appointmentId}/messages/${messageId}`, editedMessage)
  },
  reassignChat (appointmentId) {
    return client().put(`chats/${appointmentId}`)
  },
  acceptOrDeclineInterconsultation (interconsultationId, accept = false) {
    return client().put(`interconsultations/${interconsultationId}`, { accept: accept })
  }
}


// WEBPACK FOOTER //
// ./src/repositories/ChatRepository.js